export var ExtensionMessageType;

(function (ExtensionMessageType) {
  ExtensionMessageType["ExecutionComplete"] = "ExecutionComplete";
  ExtensionMessageType["Handshake"] = "Handshake";
  ExtensionMessageType["PaymentResponse"] = "PaymentResponse";
})(ExtensionMessageType || (ExtensionMessageType = {}));